import React from 'react';
import MediaQuery from 'react-responsive';
import { NavLink } from 'react-router-dom';
import { Breadcrumbs } from 'react-breadcrumbs-dynamic';

import { BreadcrumbsContainer } from './BreadcrumbComponentStyle';

export class BreadcrumbComponent extends React.Component {
    render() {
        return (
            <MediaQuery query="(min-width: 769px)">
                {matches =>
                    matches ? (
                        <BreadcrumbsContainer>
                            <Breadcrumbs
                                container={'div'}
                                containerProps={{ className: 'conteneur' }}
                                separator={<span className="separator">&gt;</span>}
                                item={NavLink}
                                finalItem="span"
                            />
                        </BreadcrumbsContainer>
                    ) : (
                        <div style={{ marginTop: '40px' }} />
                    )
                }
            </MediaQuery>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/breadcrumb/BreadcrumbComponent.js